// utils/firebase.js — Firebase Firestore via REST API

const PROJECT_ID = "webstudio-e0a6b";
const BASE_URL = `https://firestore.googleapis.com/v1/projects/${PROJECT_ID}/databases/(default)/documents/webstudio/published`;

// Convert JS value to Firestore REST format
function toFirestore(value) {
  if (value === null || value === undefined) return { nullValue: null };
  if (typeof value === "boolean") return { booleanValue: value };
  if (typeof value === "number") return Number.isInteger(value) ? { integerValue: String(value) } : { doubleValue: value };
  if (typeof value === "string") return { stringValue: value };
  if (Array.isArray(value)) return { arrayValue: { values: value.map(toFirestore) } };
  if (typeof value === "object") {
    const fields = {};
    for (const [k, v] of Object.entries(value)) fields[k] = toFirestore(v);
    return { mapValue: { fields } };
  }
  return { stringValue: String(value) };
}

// Convert Firestore REST format to JS value
function fromFirestore(field) {
  if (!field) return null;
  if ("nullValue" in field) return null;
  if ("booleanValue" in field) return field.booleanValue;
  if ("integerValue" in field) return parseInt(field.integerValue);
  if ("doubleValue" in field) return field.doubleValue;
  if ("stringValue" in field) return field.stringValue;
  if ("arrayValue" in field) return (field.arrayValue.values || []).map(fromFirestore);
  if ("mapValue" in field) {
    const obj = {};
    for (const [k, v] of Object.entries(field.mapValue.fields || {})) obj[k] = fromFirestore(v);
    return obj;
  }
  return null;
}

export async function loadPublishedContent() {
  try {
    const res = await fetch(BASE_URL);
    if (!res.ok) return null;
    const data = await res.json();
    if (!data.fields) return null;
    const result = {};
    for (const [k, v] of Object.entries(data.fields)) result[k] = fromFirestore(v);
    return result;
  } catch (err) {
    console.error("Firebase load error:", err);
    return null;
  }
}

export async function savePublishedContent(content) {
  try {
    const fields = {};
    for (const [k, v] of Object.entries(content)) fields[k] = toFirestore(v);
    const res = await fetch(BASE_URL, {
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ fields }),
    });
    if (!res.ok) {
      const err = await res.json();
      console.error("Firebase save error:", err);
      return false;
    }
    return true;
  } catch (err) {
    console.error("Firebase save error:", err);
    return false;
  }
}
